<template>
  <div>
    <div class="container">
      <div class="screen">
        <el-tabs v-model="query.type" class="order-tabs" @tab-click="tabClick">
          <el-tab-pane v-for="(item, index) in statusName" :label="item.label" :name="item.value" :index:="index"
            :key="index">
          </el-tab-pane>
        </el-tabs>
        <el-tabs v-model="query.status" class="order-tabs" @tab-click="tabClick">
          <el-tab-pane v-for="(item, index) in typeMap" :label="item.label" :name="item.value" :index:="index"
            :key="index">
          </el-tab-pane>
        </el-tabs>
        <div class="handle-box">
          <el-cascader :props="props" v-model="area_store" style="width: 240px;" placeholder="选择或搜索门店" @visible-change="visibleChange"
            @change="clearRoom" collapse-tags clearable filterable></el-cascader>
          <el-select v-model="query.room_id" clearable placeholder="房间" style="width: 160px;margin-right: 4px;">
            <el-option v-for="itm in roomOptions" :key="itm.value" :label="itm.label"
              :value="Number(itm.value)"></el-option>
          </el-select>
          <el-input v-model="query.no" style="width:180px;" placeholder="订单编号"></el-input>
          <el-input v-model="query.real_name" style="width:100px;" placeholder="客户称呼"></el-input>
          <el-input v-model="query.user_phone" style="width:130px;" placeholder="客户完整手机号"></el-input>
          <el-date-picker v-model="value" type="datetimerange" value-format="YYYY-MM-DD HH:mm:ss"
            format="YYYY-MM-DD HH:mm:ss" align="right" start-placeholder="开始日期" end-placeholder="结束日期"
            :default-time="['0000-00-00 00:00:00', '3000-00-00 23:59:59']" style="margin-right: 10px;">
          </el-date-picker>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <vue3-json-excel class="export-excel-wrapper" :json-data="json_data" :fields="json_fields"
            :before-generate="handleDownload" name="订单.xls">
            <el-button icon="el-icon-download">导出</el-button>
          </vue3-json-excel>
          <!-- <el-button icon="el-icon-download" @click="handleDownloadMore" type="success" plain>详细导出</el-button>
          <el-tooltip class="item" effect="dark" content="订单导出时必须选择时间段，并且一次性最多只能导出3个月的内容" placement="top-start">
            <el-button class="el-button-problem" icon="el-icon-warning-outline" type="text"></el-button>
          </el-tooltip> -->
        </div>
      </div>
      <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
        :cell-style="centerStyle">
        <el-table-column type="expand" width="40">
          <template #default="scope">
            <el-row :gutter="40" v-if="scope.row.time_order_list != null && scope.row.time_order_list.length > 0">
              <el-col :div="40" v-for="item in scope.row.time_order_list" v-bind:key="item.id">
                加时时间：<span class="order-field">{{ ForMatHMS(item.start_time) }}</span>-
                <span class="order-field">{{ ForMatHMS(item.end_time) }}</span>
                加时时长：<span class="order-field">{{ ((item.end_time - item.start_time) / 3600).toFixed(1) }}小时</span>
                加时价格：<span class="order-field">{{ (item.price / 100).toFixed(2) }}</span>
                加时订单：<span class="order-field">{{ item.no }}</span>
                订单状态：<span class="order-field">{{ statusMap.get(item.status) }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="40" v-if="scope.row.order_room !== null">
              <el-col :span="40">
                房间时间：<span class="order-field">{{ ForMatHMS(scope.row.order_room.start_time) }}</span>-
                <span class="order-field">{{ ForMatHMS(scope.row.order_room.end_time) }}</span>
                房间时长：<span class="order-field">{{
                  (scope.row.order_room.end_time - scope.row.order_room.start_time) / 3600
                }}小时</span>
                房间价格：<span class="order-field">{{ (scope.row.order_room.price / (100)).toFixed(2) }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="40" v-if="scope.row.order_meal !== null">
              <el-col :span="40">套餐名称：<span class="order-field">{{ scope.row.order_meal.meal_name }}</span>
                套餐时长：<span class="order-field">{{ scope.row.order_meal.hour }}小时</span>
                套餐价格：<span class="order-field">{{ (scope.row.order_meal.price / 100).toFixed(2) }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="40" v-if="scope.row.order_voucher">
              <el-col :div="40" >
                卡券名称：<span class="order-field">{{ scope.row.order_voucher.name }}</span>
                卡券价格：<span class="order-field">{{ scope.row.order_voucher.price}}</span>
              </el-col>
            </el-row>
            <el-row :gutter="40" v-if="scope.row.product_list && scope.row.product_list.length > 0">
              <el-col :div="40" v-for="item in scope.row.product_list" v-bind:key="item.id">
                商品名称：<span class="order-field">{{ item.product_name }}</span>
                规格名称：<span class="order-field">{{ item.specs_name }}</span>
                商品数量：<span class="order-field">{{ item.num }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="40" v-if="scope.row.pick_store_id === 0 && scope.row.order_address">
              <el-col :div="40">
                收货方式：<span class="order-field">物流寄送</span>
                收货人：<span class="order-field">{{ scope.row.order_address.consignee }}</span>
                联系方式:<span class="order-field">{{ scope.row.order_address.mobile }}</span>
                省市区：<span class="order-field">{{
                  scope.row.order_address.province + scope.row.order_address.city + scope.row.order_address.area
                }}</span>
                详细地址：<span class="order-field">{{ scope.row.order_address.content }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="40" v-if="scope.row.pick_store_id != 0">
              <el-col :div="40">
                收货方式：<span class="order-field">门店自提</span>
                自提门店：<span class="order-field">{{ scope.row.store.name }}</span>
                店长电话:<span class="order-field">{{ scope.row.store.phone }}</span>
                提货人:<span class="order-field">{{ scope.row.nickname }}</span>
                提货人电话:<span class="order-field">{{ scope.row.phone }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="40" v-if="scope.row.type === 5">
              <el-col :div="40">
                充值金额：<span class="order-field">{{ (scope.row.order_balance.charge / 100).toFixed(2) }}</span>
                赠送金额：<span class="order-field">{{
                  ((scope.row.order_balance.deposit - scope.row.order_balance.charge) / 100).toFixed(2)
                }}</span>
                到账金额：<span class="order-field">{{ (scope.row.order_balance.deposit / 100).toFixed(2) }}</span>
                通用类型：<span class="order-field">{{ (scope.row.store_id == 0 ? "平台通用" : scope.row.store_name) }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="40" v-if="scope.row.order_coupon != null">
              <el-col :div="40">
                优惠名称：<span class="order-field">{{ scope.row.order_coupon.name }}</span>
                优惠金额：<span class="order-field">{{ (scope.row.order_coupon.use_amount / 100).toFixed(2) }}</span>
                优惠券ID：<span class="order-field">{{ scope.row.user_coupon_id}}</span>
                起止时间：<span class="order-field">{{ ForMatHMS(scope.row.order_coupon.start_time) }}</span>-
                <span class="order-field">{{ ForMatHMS(scope.row.order_coupon.end_time) }}</span>
                优惠说明：<span class="order-field">{{ scope.row.order_coupon.memo }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="40" v-if="scope.row.integral != null">
              <el-col :div="40">
                订单状态：<span class="order-field">{{ integralMap.get(scope.row.integral.type) }}</span>
                积分描述：<span class="order-field">{{ scope.row.integral.memo }}</span>
                {{ (scope.row.integral.type != 2) ? '获得' : '使用' }}数量：<span class="order-field">{{
                  scope.row.integral.score }}</span>
                {{ (scope.row.integral.type) != 2 ? '可抵金额' : '抵扣金额' }}：<span class="order-field">{{
                  (scope.row.integral.score / 100).toFixed(2) }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="40" v-if="scope.row.memo != ''">
              <el-col :div="40">
                备注：<span class="order-field">{{ scope.row.memo }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="40">
              <el-col :div="40">
                <el-button
                  v-if="scope.row.type !== 5 && scope.row.order_pay_notify !== null && (scope.row.order_pay_notify.refund + scope.row.order_pay_notify.refund_apply) <= scope.row.order_pay_notify.money"
                  type="text" class="warning" @click="handleRefund(scope.$index, scope.row)">申请退款
                </el-button>
                <el-tooltip
                  v-if="scope.row.order_pay_notify !== null && (scope.row.order_pay_notify.refund + scope.row.order_pay_notify.refund_apply) <= scope.row.order_pay_notify.money"
                  class="item" effect="dark" content="如果存在加时订单，请先申请加时订单退款再申请原订单，请根据错误提示进行退款" placement="top-start">
                  <el-button class="el-button-problem" icon="el-icon-warning-outline" type="text"></el-button>
                </el-tooltip>
                <el-button v-if="scope.row.status == 4 && scope.row.type == 4 && scope.row.pick_store_id == 0"
                  type="text" class="blue" @click="sendProduct(scope.$index, scope.row)">发货
                </el-button>
                <el-tooltip v-if="scope.row.status == 4 && scope.row.type == 4 && scope.row.pick_store_id == 0"
                  class="item" effect="dark" content="点击添加物流上传所有该订单相关的物流信息，请确保该订单相关的所有物流信息全部上传之后再点击发货完成"
                  placement="top-start">
                  <el-button class="el-button-problem" icon="el-icon-warning-outline" type="text"></el-button>
                </el-tooltip>
                <el-button v-if="scope.row.status == 1" type="text" class="blue"
                  @click="orderCancel(scope.$index, scope.row)">取消订单
                </el-button>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
        <el-table-column prop="store_name" label="门店" header-align="center" min-width="200"></el-table-column>
        <el-table-column prop="no" label="订单编号" width="160" align="center"></el-table-column>
        <el-table-column prop="type_name" label="订单类型" width="140" align="center"></el-table-column>
        <el-table-column prop="nickname" label="客户称呼" header-align="center" width="100" show-overflow-tooltip>
          <template #default="scope">
            {{ scope.row.real_name || scope.row.nickname }}
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" align="center" width="110"></el-table-column>
        
        <!-- <el-table-column prop="room_name:" label="房间" header-align="center" width="80" show-overflow-tooltip>
          <template #default="scope">{{ scope.row.order_room != null ? scope.row.order_room.room_name : "" }}</template>
        </el-table-column> -->
        <el-table-column prop="title" label="套餐/产品"  width="140"  header-align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="total_money" label="订单金额" align="right" width="120" header-align="center">
          <template #default="scope">{{
            scope.row.order_meal ? (scope.row.order_meal.price / 100).toFixed(2) : (scope.row.total_money /
              100).toFixed(2)
          }}
          </template>
          <template #header>
            <span>订单金额</span>
            <el-tooltip class="box-item" effect="dark" content="订单金额：即该订单包括使用套餐之后的总金额" placement="top">
              <el-button icon="el-icon-warning" type="text" style="color: #777"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="total_money" label="优惠金额" header-align="center" align="right" width="120">
          <template #header>
            <span>优惠金额</span>
            <el-tooltip class="box-item" effect="dark" content="优惠金额：即该订单所使用的优惠的总和，具体优惠详情可点击左侧三角进行查看" placement="top">
              <el-button icon="el-icon-warning" type="text" style="color: #777"></el-button>
            </el-tooltip>
          </template>
          <template #default="scope">{{
            ((scope.row.order_meal ? (scope.row.order_meal.price / 100) : (scope.row.total_money / 100)) -
              (scope.row.money / 100)).toFixed(2)
          }}
          </template>
        </el-table-column>
        <el-table-column prop="money" label="支付金额" align="right" width="120" header-align="center">
          <template #header>
            <span>支付金额</span>
            <el-tooltip class="box-item" effect="dark" content="支付金额：即该订单用户最后所支付的金额" placement="top">
              <el-button icon="el-icon-warning" type="text" style="color: #777"></el-button>
            </el-tooltip>
          </template>
          <template #default="scope">{{ (scope.row.money / 100).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column prop="status_name" label="支付方式" header-align="center" width="120">
          <template #default="scope">
            {{ scope.row.order_pay_notify ? payMap.get(scope.row.order_pay_notify.type) : '' }}
            <!-- {{ payMap.get(scope.row.order_pay_notify.type) }} -->
          </template>
        </el-table-column>
        <el-table-column prop="status_name" label="订单状态" header-align="center" width="80"></el-table-column>

        <el-table-column prop="pay_at" :formatter="dateFormatHMS" label="支付时间" header-align="center"
          width="170"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="query.page"
          :page-sizes="[10, 20, 50, 100, 200]" :page-size="10" layout="total,sizes, prev, pager, next"
          :total="pageTotal">
        </el-pagination>
      </div>
    </div>
    <el-dialog v-model="refundVisable" :close-on-click-modal="false" @close="close" title="退款" width="500px">
      <el-form ref="form" :model="form">
        <div class="hi-row">
          <div>
            <span>金额：</span>
            <el-input-number v-model="refundForm.money" :controls="false" :precision="2" :min="0"
              :max="refundForm.maxMoney"></el-input-number>
            <span style="margin-left: 5px;color: gray;">剩余可退金额<span style="color:red;">{{ refundForm.maxMoney
                }}元</span></span>
          </div>
        </div>
        <br /><br />
        <el-input v-model="refundForm.memo" :rows="3" type="textarea" show-word-limit maxlength="64" placeholder="备注" />
        <div style="text-align: right; margin-top: 10px">
          <el-button type="primary" @click="orderRefund">确认提交</el-button>
        </div>
      </el-form>
    </el-dialog>
    <!--    发货-->
    <el-dialog v-model="expressVisible" :close-on-click-modal="false" @close="close"
      :title="[code ? '编辑' : '添加'] + '物流'" width="50%">
      <el-form ref="form" :model="expressForm" label-width="180px" :rules="phonerules">
        <el-form-item label="订单编号" v-if="expressForm.order_id">
          {{ expressForm.order_no }}
        </el-form-item>
        <el-form-item prop="firm_id" label="物流公司：">
          <el-select v-model.number="expressForm.firm_id" clearable>
            <el-option v-for="item in firmData" :key="item.value" :label="item.label"
              :value="Number(item.value)"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物流金额:">
          <el-input v-model="expressForm.money" class="w200"></el-input>
          元
        </el-form-item>
        <el-form-item label="物流单号:" prop="no">
          <el-input v-model="expressForm.no" class="w300"></el-input>
        </el-form-item>
        <el-form-item label="寄件人:" prop="send_name">
          <el-input v-model="expressForm.send_name" class="w150"></el-input>
        </el-form-item>
        <el-form-item label="寄件人手机号:" prop="send_phone">
          <el-input v-model="expressForm.send_phone" class="w200"></el-input>
        </el-form-item>
        <el-form-item label="收件人:" props="receive_name">
          <el-input v-model="expressForm.receive_name" class="w150"></el-input>
        </el-form-item>
        <el-form-item label="收件人手机号:" prop="receive_phone">
          <el-input v-model="expressForm.receive_phone" class="w200"></el-input>
        </el-form-item>
        <el-form-item label="收件人地址:" props="receive_address">
          <el-input type="textarea" v-model="expressForm.receive_address" class="w400" resize="none"
            rows="5"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: right; margin-top: 10px">
        <el-button @click="expressVisible = false">取消</el-button>
        <el-button type="primary" @click="saveExpressSubmit">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog v-model="sendVisible" :close-on-click-modal="false" @close="close" title="发货" width="30%">
      <el-button type="primary" @click="handleExpress">添加物流</el-button>
      <el-button type="success" @click="sendSuccess">发货完成</el-button>
    </el-dialog>
  </div>
</template>

<script>
import { getOrderList, getOrderStatusName, applyRefund, sendProduct, orderCancel} from "@/api/order";
import { PAY_TYPE } from "@/constant/pay";
import { getRoomOption } from '@/api/room'
import { getAreaOption, getStoreOption } from "@/api/store";
import moment from "moment";
import { addExpress, getFirmList } from "@/api/express";
import { status } from "@/constant/status"
import { ElCol, ElRow } from "element-plus";
import { downLoad } from "../utils/download";

export default {
  name: "OrderTable",
  components: { ElCol, ElRow },
  data() {
    return {
      query: {
        store_id: null,
        room_id: null,
        real_name: "",
        nickname: '',
        user_phone: "",
        add_start: null,
        add_end: null,
        add_start_utc: null,
        add_end_utc: null,
        isvalidate: null,
        status: 0,
        type: 0,
        page: 1,
        page_size: 10,
      },
      value3: null,
      tableData: [],
      pageTotal: 0,
      roomOptions: [], // 房间信息
      storeOptions: [], // 门店信息
      typeMap: [], // 订单类型
      integralList: [
        { value: 1, label: '赠送' },
        { value: 2, label: '使用' },
        { value: 3, label: '退回' },
        { value: 4, label: '待进账' }
      ],
      integralMap: new Map(),
      statusName: [], // 状态名称
      form: {
        room: [
          {
            room_id: undefined,
            start_time: '',
            hour: 1
          }
        ],
        store_id: undefined
      },
      refundVisable: false, // 退款弹框
      refundForm: {
        order_id: 0,//订单ID
        money: 0, //退款金额
        maxMoney: 0,//剩余退款金额
        memo: "", //退款描述
      }, //退款数据
      json_fields: { //如果命名的标题有空格,需要用双引号
        订单编号: "no",
        订单类型: "type_name",
        客户: "name",
        手机号: "phone",
        '门店/平台': "store_type_name",
        房间: "order_room.room_name",
        套餐: "title",
        订单金额: "order_money",
        优惠金额: "yh_money",
        支付金额: "money",
        支付方式: "pay_type",
        订单状态: "status_name",
        收款时间: "pay_at",
      },
      json_data: [],
      firmData: [],
      expressVisible: false,
      expressForm: {
        order_id: null,
        firm_id: null,
        money: null,
        no: '',
        send_name: '',
        send_phone: '',
        receive_name: '',
        receive_phone: '',
        receive_address: ''
      },
      code: null,
      phonerules: {
        send_phone: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          { min: 11, max: 11, message: "请输入11位手机号码", trigger: "blur" },
        ],
        receive_phone: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          { min: 11, max: 11, message: "请输入11位手机号码", trigger: "blur" },
        ],
        no: [{ required: true, message: "请输入物流单号", trigger: "blur" },],
        send_name: [{ required: true, message: "请输入寄件人姓名", trigger: "blur" },],
        receive_name: [{ required: true, message: "请输入收件人姓名", trigger: "blur" },],
        receive_address: [{ required: true, message: "请输入收件人地址", trigger: "blur" },],
      },
      sendVisible: false,
      sendData: {
        index: null,
        order_id: null
      },
      value: [],
      areaOptions: [],
      area_store: [],
      props: {
        // checkStrictly: true,
        lazy: true,
        lazyLoad: this.lazyLoad
      },
      statusMap: new Map(),
      payMap: new Map(),
    };
  },
  computed: {
    disabled() {
      let valid = this.form.room.some(item => {
        return item.room_id && item.start_time && item.hour
      })
      return this.form.store_id && valid
    },
    status() {
      return status
    },
    pay_type() {
      return PAY_TYPE
    },
  },
  created() {
    this.getData();
    this.getStoreOption();
    this.getStatusName();
    this.getFirmOptions()
    this.getIntegral()
    this.getStatus()
  },
  methods: {
    centerStyle() {
      return 'text-align:center;'
    },
    getIntegral() {
      this.integralList.forEach(item => {
        this.integralMap.set(item.value, item.label)
      })
    },
    getStatus() {
      this.status.forEach(item => {
        this.statusMap.set(item.value, item.label)
      })
      this.pay_type.forEach(item => {
        this.payMap.set(item.value, item.label)
      })
    },
    dateFormat: function (row, column) {
      const date = row[column.property];
      if (date === undefined || date === 0) {
        return "";
      }
      return moment(parseInt(date + "000")).format("YYYY-MM-DD")
    },
    dateFormatHMS: function (row, column) {
      const date = row[column.property];
      if (date === undefined || date === 0) {
        return "";
      }
      return moment(parseInt(date + "000")).format("YYYY-MM-DD HH:mm:ss")
    },
    ForMatHMS(date) {
      return moment(parseInt(date + "000")).format("YYYY-MM-DD HH:mm:ss")
    },
    lazyLoad(node, resolve) {
      const { level } = node;
      if (level === 0) {
        this.getAreaOptions()
        let nodes = []
        if (this.areaOptions !== []) {
          setTimeout(() => {
            nodes = this.areaOptions.map(item => ({
              value: item.value,
              label: item.label,
              leaf: level === 1
            }));
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }, 500);
        }
      }
      if (level === 1) {
        let nodes = []
        this.getStoreOption(node.value)
        if (this.storeOptions !== []) {
          setTimeout(() => {
            nodes = this.storeOptions.map(item => ({
              value: item.value,
              label: item.label,
              leaf: level === 1
            }));
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }, 500);
        }
      }
    },
    visibleChange(val) {
      setTimeout(() => {
        if (!val && this.area_store != null && this.area_store.length > 1) {
          this.query.store_id = this.area_store[1]
          this.getRoomOption(this.query.store_id)
        }
      }, 200)
    },
    // 获取地址列表
    getAreaOptions() {
      getAreaOption().then(res => {
        this.areaOptions = res
      })
    },
    // 获取 easy-mock 的模拟数据
    getData() {
      this.query.area_id = this.area_store !== null ? this.area_store[0] : null
      this.query.store_id = (this.area_store !== null && this.area_store.length > 1) ? this.area_store[1] : null
      if ((this.value != null) && (this.value.length != 0)) {
        this.query.add_start = moment(this.value[0]).unix()
        this.query.add_end = moment(this.value[1]).unix()
      } else if (this.value == null) {
        this.query.add_start = null
        this.query.add_end = null
      }
      getOrderList(this.query).then(res => {
        this.tableData = res.data
        if (this.query.page === 1) {
          this.pageTotal = res.count
        }
      })
    },

    async handleDownload() {
      if ((this.value != null) && (this.value.length != 0)) {
        this.query.add_start = moment(this.value[0]).unix()
        this.query.add_end = moment(this.value[1]).unix()
      } else if (this.value == null) {
        this.query.add_start = null
        this.query.add_end = null
      }
      let start_time = this.query.add_start
      let end_time = this.query.add_end
      let isNineThree = (end_time - start_time) < 8035200
      if (start_time != null && end_time != null && isNineThree) {
        this.json_data = []
        this.query.page_size = -1
        await getOrderList(this.query).then(res => {
          let that = this
          res.data.forEach(item => {
            item.no += '&nbsp;'
            item.order_money = item.order_meal ? (item.order_meal.price / 100).toFixed(2) : (item.total_money / 100).toFixed(2)
            item.money /= 100
            // item.pay_type =  that.payMap.get(item.order_pay_notify.type)
            item.pay_type =  item.order_pay_notify ? that.payMap.get(item.order_pay_notify.type) : '待支付'
            item.yh_money = ((item.order_meal ? (item.order_meal.price / 100) : item.total_money / 100) - item.money).toFixed(2)
            item.store_type_name = item.store_name || '平台通用'
            item.name = item.real_name || item.nickname
            if (item.c_at === 0) {
              item.pay_at = "";
            } else {
              item.pay_at = moment(parseInt(item.c_at + "000")).format("YYYY-MM-DD HH:mm:ss")
            }
            that.json_data.push(item)
          })
          this.query.page_size = 10
        })
      } else if (start_time == null || end_time == null) {
        this.$message.error('请选择开始日期和结束日期，最多可导出3个月的数据')
      } else if (!isNineThree) {
        this.$message.error('只能同时导出最多3个月的数据，请重新选择开始时期和结束时期')
      }
    },
    handleDownloadMore() {
      if ((this.value != null) && (this.value.length != 0)) {
        this.query.add_start = moment(this.value[0]).unix()
        this.query.add_end = moment(this.value[1]).unix()
      } else if (this.value == null) {
        this.query.add_start = null
        this.query.add_end = null
      }
      let start_time = this.query.add_start
      let end_time = this.query.add_end
      let isNineThree = (end_time - start_time) < 8035200
      if (start_time != null && end_time != null && isNineThree) {
        this.query.page_size = 10000
        downLoad('admin/getOrderExcel', this.query, '订单详细列表')
      } else if (start_time == null || end_time == null) {
        this.$message.error('请选择开始日期和结束日期，最多可导出3个月的数据')
      } else if (!isNineThree) {
        this.$message.error('只能同时导出最多3个月的数据，请重新选择开始时期和结束时期')
      }
    },

    tabClick() {
      this.query.page = 1
      this.statusName.forEach(item => {
        if(item.value == this.query.type){
          this.typeMap = item.status
        }
      })
      this.getData()
    },

    // 分页导航
    handlePageChange(val) {
      this.query.page = val
      this.getData()
    },

    handleSizeChange(val) {
      this.query.page_size = val
      this.getData()
    },

    handleSearch() {
      this.query.page = 1
      this.getData()
    },

    handleAdd() {
      this.$refs.form && this.$refs.form.clearValidate()
      this.editVisable = true
    },

    handleClose() {
      alert("关闭订单")
    },

    //退款弹框
    handleRefund(index, item) {
      this.refundForm.memo = ""
      this.refundForm.money = 0
      this.refundForm.maxMoney = (item.order_pay_notify.money - item.order_pay_notify.refund - item.order_pay_notify.refund_apply) / 100
      this.refundForm.order_id = item.order_pay_notify.order_id
      this.refundVisable = true
    },

    //提交退款
    orderRefund() {
      // if (this.refundForm.money === 0) {
      //   this.$message.error('请输入退款金额')
      //   return
      // }

      let param = {
        refund: this.refundForm.money * 100,
        memo: this.refundForm.memo
      }
      applyRefund(this.refundForm.order_id, param).then((res) => {
        if (res === true) {
          this.$message.success('申请成功！')
          this.getData()
          this.refundVisable = false
        }
      })

    },

    // 获取物流公司列表
    getFirmOptions() {
      getFirmList().then(res => {
        this.firmData = res
      }
      )
    },

    // 发货
    sendProduct(index, item) {
      this.sendVisible = true
      this.sendData.index = index
      this.sendData.order_id = item.id
    },

    // 添加物流
    handleExpress() {
      this.expressForm = {}
      this.expressForm.receive_phone = this.tableData[this.sendData.index].order_address.mobile
      this.expressForm.receive_name = this.tableData[this.sendData.index].order_address.consignee
      this.expressForm.receive_address = this.tableData[this.sendData.index].order_address.province + this.tableData[this.sendData.index].order_address.city + this.tableData[this.sendData.index].order_address.area + this.tableData[this.sendData.index].order_address.content
      this.expressVisible = true
    },

    // 添加成功
    saveExpressSubmit() {
      let data = JSON.parse(JSON.stringify(this.expressForm))
      data.money = parseInt(data.money * 100)
      data.order_id = this.sendData.order_id
      addExpress(this.expressForm.id, data).then(res => {
        if (res === true) {
          this.$message.success('添加成功')
          this.expressVisible = false
          this.getData()
        }
      }
      )
    },

    // 取消订单
    orderCancel(index, item) {
      orderCancel(item.id).then(res => {
        if (res === true) {
          this.$message.success('已取消！')
          this.getData()
        }
      })
    },

    // 发货成功
    sendSuccess() {
      this.sendVisible = false
      sendProduct(this.sendData.order_id).then(res => {
        if (res === true) {
          this.$message.success('发货成功！')
          this.getData()
        }
      })
    },

    getStatusName() {
      getOrderStatusName().then(res => {
        this.statusName = res
        this.typeMap = this.statusName[0].status
      })
    },
    // 获取房间信息
    getRoomOption(id) {
      this.query.room_id = null
      getRoomOption(id).then(res => {
        this.roomOptions = res
      })
    },

    clearRoom(val) {
      if (val === null) {
        this.roomOptions = []
        this.query.room_id = null
      }
    },

    getStoreOption(id) {
      getStoreOption(id).then(res => {
        this.storeOptions = res
      })
    },

    close() {
      if (!this.editVisable) return
      this.editVisable = false
      this.form.store_id = undefined
      this.form.room = [
        {
          room_id: undefined,
          start_time: '',
          hour: 1
        }
      ]
    },

    add() {
      this.form.room.push({
        room_id: undefined,
        start_time: '',
        hour: 1
      })
    },

    del(index) {
      this.form.room.splice(index, 1)
    },
  }
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 10px;
}

.el-input {
  width: 300px;
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
}

.el-button {
  margin-right: 10px;
}

.table {
  width: 100%;
  font-size: 14px;
}

.hi-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}

.el-icon-close {
  margin-right: 10px;
}

.red {
  color: red;
}

.warning {
  color: #e6a23c;
}

.order-field {
  color: #0054fd;
  margin-left: 20px;
  margin-right: 20px;
}

.screen {
  /*position: fixed;*/
  /*z-index: 1;*/
  /*margin: 0 auto;*/
  background: white;
  /*top: 115px;*/
  margin-right: 20px;
  padding-right: 20px;
  box-sizing: border-box;
  transition: width 0.3s linear;
}

.container {
  /*padding-top: 150px;*/
  position: relative;
}

.w100 {
  width: 100px !important;
}

.w150 {
  width: 150px !important;
}

.el-table {
  height: calc(59vh);
  overflow: auto;
}

.w200 {
  width: 200px !important;
}

.w150 {
  width: 150px !important;
}

.w300 {
  width: 300px !important;
}

.w400 {
  width: 80% !important;
}

.el-table::before {
  height: 0;
}

/deep/ .el-cascader {
  width: 300px;
  margin-right: 10px;
}

.el-button-problem {
  font-size: 20px;
  margin-left: 10px;
  //margin-top: 15px;
}
</style>
